import React from "react";
import classNames from "classnames";

const LeftSide = ({children}) => (
  <div
    data-testid={"EntityList-LeftSide"}
    className={classNames("d-flex mr-1")}>
    {children}
  </div>
);

export default LeftSide;
